export default {
  namespaced: true,
  state: {
    isOpen: false
  },
  mutations: {
    isOpen (state, payload) {
      state.isOpen = payload
    }
  },
  getters: {
    isOpen: state => {
      return state.isOpen
    }
  },
  actions: {
    open ({commit, dispatch, state}) {
      commit('isOpen', true)
    },
    close ({commit, dispatch, state}) {
      commit('isOpen', false)
    },
    toggle ({commit, dispatch, state}) {
      commit('isOpen', !state.isOpen || false)
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/ModuleAppMenu/store/index.js